var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"menu"},[_c('SideMenu')],1),_c('div',{staticClass:"card"},[_c('UserCard')],1),_c('vue-page-transition',{staticClass:"details",attrs:{"name":"fade-in-right"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }